import { AxiosInstance } from 'axios';
import http from '@student/http';

function getCardSessionToken(http: AxiosInstance) {
  return async (loanOrderId: string): Promise<string> => {
    const { data } = await http.get('/update-payment/card-session-token', {
      params: { loanOrderId },
    });
    return data;
  };
}

export default getCardSessionToken(http);
